export default __webpack_public_path__ + "static/media/Fruhling-Ammersee-Yoga.d2753173.JPG";